import { AxiosRequestConfig } from "axios";
import { SystemTermRequestModel, SystemTermsModel } from "models/systemTerms";
import ApiService from "utils/api/api-service";
import ApiResponse, { isError } from "utils/api/models/api-response";
import { ApiErrorNotification } from "utils/ui/notificationService";

class SystemTerms extends ApiService {
  constructor(config?: AxiosRequestConfig) {
    super({
      baseURL: process.env.REACT_APP_API_URL,
      ...config,
    });
  }
  public async Fetch(): Promise<ApiResponse<SystemTermsModel[]>> {
    return this.get("/api/system-term");
  }

  public async Post(data: any): Promise<ApiResponse<SystemTermRequestModel>> {
    return this.post("/api/system-term", data);
  }
  public async Delete(id: any): Promise<ApiResponse<SystemTermsModel>> {
    return this.delete(`/api/system-term/${id}`);
  }
  public async Update(id: any, data: any): Promise<ApiResponse<any>> {
    return this.post(`/api/system-term/${id}`, data);
  }
}

const systemTermsService = new SystemTerms();

export const FetchSystemTerms = async () => {
  const result: ApiResponse<SystemTermsModel[]> =
    await systemTermsService.Fetch();
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};

export const PostSystemTerm = async ({
  data,
}: {
  data: SystemTermRequestModel;
}) => {
  const result: any = await systemTermsService.Post(data);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};

export const DeleteSystemTerm = async (id: any) => {
  const result: any = await systemTermsService.Delete(id);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const UpdateSystemTerm = async ({
  id,
  data,
}: {
  id: number;
  data: any;
}) => {
  const result: any = await systemTermsService.Update(id, data);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
